import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { Subscription } from 'rxjs';
import { TablaSearchService } from '../buscador-tabla/tabla-search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
@AutoUnsubscribe()
export class SearchComponent implements OnInit {

  @Output() modalCloseDatos = new EventEmitter<any>();

  subs1: Subscription;
  subs2: Subscription;
  focusSubs1 = false;
  focusSubs2 = false;
 datosArcadeCode:any;
  constructor(
    public _tablaSearchService: TablaSearchService,
    private translateService: TranslateService
    ) { }
    

    
  ngOnInit() {
    this.observersForms();
  }
  get f() {
    return  this._tablaSearchService.formInvoices.controls;
  }

  observersForms() {
    // Cada vez que hay un cambio de valor en el input codigo
    this.subs1 =   this._tablaSearchService.formInvoices.get('searchCustomerCode').valueChanges.subscribe(val => {
      // Si no hay valor en el input lo seteo vacio
      if (val === '') {
          this._tablaSearchService.formInvoices.get('searchCustomerName').setValue('', {emitEvent: false});
        // Por tanto el codigo no es valido tampoco
          this._tablaSearchService.formInvoices.get('searchCustomerCode').setErrors({ 'invalid': true });
      }
      // si hay informacion llamo al servicio con el codigo
     const b = {
        customerCode: val,
        customerName: this._tablaSearchService.formInvoices.get('searchCustomerName').value
      };
      this._tablaSearchService.searchBoxResults(b);

    });
    //Cada vez que hay un cambio de valor en el input nombre
    this.subs2 =   this._tablaSearchService.formInvoices.get('searchCustomerName').valueChanges.subscribe(val => {
      if (val === '') {
          this._tablaSearchService.formInvoices.get('searchCustomerCode').setValue('', {emitEvent: false});
          this._tablaSearchService.formInvoices.get('searchCustomerCode').setErrors({ 'invalid': true });
      }
      const b = {
        customerCode:   this._tablaSearchService.formInvoices.get('searchCustomerCode').value,
        customerName: val
      };
      this._tablaSearchService.searchBoxResults(b);
    });
  }

  //pulsando en buscar
  search(name) {
    if (name === 'searchCustomerCode') {
      this.focusSubs1 = true;  //codigo
    } else {
      this.focusSubs2 = true; //nombre
    }

    setTimeout(() => {
      const b = {
        customerCode:   this._tablaSearchService.formInvoices.get('searchCustomerCode').value,
        customerName:   this._tablaSearchService.formInvoices.get('searchCustomerName').value,
      };
      this._tablaSearchService.searchBoxResults(b);
      this._tablaSearchService.boxResults = true;
    }, 250);
  }

  cancelSearch(name) {
    if (name === 'searchCustomerCode') {
      this.focusSubs1 = false;
    } else {
      this.focusSubs2 = false;
    }
    setTimeout(() => {
      if (!this.focusSubs1 || !this.focusSubs2 ) {
        this._tablaSearchService.boxResults = false;
      }
    }, 200);
  }

  anadido(event){
     this.datosArcadeCode = event.dataItem;
    // this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('arcadCode').setValue(codeArcade.dataItem.LinkedCode);
  }


  closeModal(datos) {
    if (datos === 'anadir') {
        this.modalCloseDatos.emit( this.datosArcadeCode);
    } else {
      this.modalCloseDatos.emit('cerrar');
    }
  }


}

